module.exports = __webpack_public_path__ + "static/media/joe-biden.5271d637.jpg";